import React, { useState } from "react";
import styles from "./index.module.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { sendOTP } from "../../../api/auth";
const ForgotYourPassword = (props) => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  const debounce = (func) => {
    let timer;
    return () => {
      clearTimeout(timer);
      timer = setTimeout(func, 300);
    };
  };

  const handleGetCode = () => {
    if (!loader) {
      const username = props.userEmail;
      if (username.length === 0) {
        toast.error("Username is required!");
      } else {
        setLoader(true);
        sessionStorage.setItem("username", username);
        sendOTP(username).then((res) => {
          setLoader(false);
          if (res.status === "success") {
            toast.success(res.message);
            props.setVisibility({
              forgotYourPassword: false,
              confirmOTP: true,
              enterNewPassword: false,
            });
          } else {
            toast.error(res.message);
          }
        });
      }
    }
  };

  return (
    <div className={styles["container"]}>
      <div className={styles["form"]}>
        <div className={styles["text"]}>
          <div className={styles["main"]}>Forgot your password?</div>
          <div className={styles["sub"]}>
            Enter your username to receive a code via email.
          </div>
        </div>

        <div className={styles["inputs"]}>
          <div className={styles["input_box"]}>
            <div className={styles["label"]}>User name</div>
            <div className={styles["input"]}>
              <input
                type="text"
                placeholder="Username"
                value={props.username}
                onChange={(e) => props.setUsername(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className={styles["submission"]}>
          <div className={styles["main_cta"]}>
            <div className={styles["button"]} onClick={debounce(handleGetCode)}>
              Get Code
            </div>
            <div
              className={styles["button"] + " " + styles["back"]}
              onClick={() => navigate("/")}
            >
              Back
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotYourPassword;
